import { render, staticRenderFns } from "./OrderDetailDialog.vue?vue&type=template&id=c105f028&scoped=true"
import script from "./OrderDetailDialog.vue?vue&type=script&lang=js"
export * from "./OrderDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailDialog.vue?vue&type=style&index=0&id=c105f028&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c105f028",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c105f028')) {
      api.createRecord('c105f028', component.options)
    } else {
      api.reload('c105f028', component.options)
    }
    module.hot.accept("./OrderDetailDialog.vue?vue&type=template&id=c105f028&scoped=true", function () {
      api.rerender('c105f028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/OrderDetailDialog.vue"
export default component.exports